import { Input } from '@nextui-org/react'
import { Button as AntdButton } from 'antd'
import decode from 'jwt-decode'
import { Check } from 'phosphor-react'
import { func } from 'prop-types'
import React, { useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import toast from 'react-hot-toast'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { Link, useParams } from 'react-router-dom'
import holloLogo from '../../../assets/logos/logo profil .png'
import { setTalent } from '../../../redux/reducers/talentSlice'
import AuthTalent from '../../../services/AuthTalent'
import { errorsForm } from '../../../services/errorsForm'
import { checkNumber, checkSpecial, checkUppercase } from '../../../utils/utils'
import { checkFeatureFlag } from '../../../utils/featureFlag'
import j2bdLogo from '../../../assets/images/j2bd.svg'

const propTypes = {
  handleNextStep: func.isRequired,
}

const SignUp = ({ handleNextStep }) => {
  const { t } = useTranslation(['login', 'common', 'settings'], {
    useSuspense: false,
  })
  const { token } = useParams()
  const decoded = decode(token)
  const dispatch = useDispatch()

  const [hasUppercase, setHasUppercase] = useState(null)
  const [hasNumber, setHasNumber] = useState(null)
  const [hasSpecial, setHasSpecial] = useState(null)
  const [newPassword, setNewPassword] = useState('')

  const [isLoading, setIsLoading] = useState(false)
  const [isValidPassword, setIsValidPassword] = useState(false)

  const handlePasswordChange = (e) => {
    setNewPassword(e.target.value)
    setHasNumber(checkNumber(e.target.value))
    setHasSpecial(checkSpecial(e.target.value))
    setHasUppercase(checkUppercase(e.target.value))

    if (
      checkNumber(e.target.value) &&
      checkSpecial(e.target.value) &&
      checkUppercase(e.target.value) &&
      e.target.value.length > 7
    ) {
      setIsValidPassword(true)
    } else {
      setIsValidPassword(false)
    }
  }

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm()

  const onSubmit = async () => {
    try {
      setIsLoading(true)
      await AuthTalent.signup({
        id: decoded.id,
        companyId: decoded.companyId,
        password: newPassword,
        active: true,
      })
      toast.success(t('login:accountCreated.success.message'))
      const response = await AuthTalent.login(decoded.email, newPassword)
      dispatch(setTalent(response.talent))
      handleNextStep()
    } catch (err) {
      errorsForm(err, t)
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        height: '100vh',
        width: 300,
      }}
    >
      <header style={{ width: '100%' }}>
        <img
          src={checkFeatureFlag ? j2bdLogo : holloLogo}
          height={40}
          alt=""
          className="logo"
        />
        <h3>{t('login:signUp')}</h3>
      </header>
      <form
        style={{ display: 'flex', flexDirection: 'column', gap: 10 }}
        onSubmit={handleSubmit(onSubmit)}
      >
        <div className="password-rules-list">
          <div
            className={`${newPassword.length > 7 ? 'is-valid' : ''} check-tag`}
          >
            <Check size={20} />{' '}
            <span>{t('settings:general.password.eightCharacters')}</span>
          </div>
          <div className={`${hasUppercase && 'is-valid'} check-tag`}>
            <Check size={20} />{' '}
            <span>{t('settings:general.password.uppercase')}</span>
          </div>
          <div className={`${hasSpecial && 'is-valid'} check-tag`}>
            <Check size={20} />{' '}
            <span>
              {t(
                'settings:general.password.specials',
                'Au moins un caractère special',
              )}
            </span>
          </div>
          <div className={`${hasNumber && 'is-valid'} check-tag`}>
            <Check size={20} />{' '}
            <span>{t('settings:general.password.digit')}</span>
          </div>
        </div>

        <Controller
          name="password"
          id="password"
          control={control}
          onChange={handlePasswordChange}
          render={({ field }) => (
            <Input.Password
              clearable
              shadow
              size="lg"
              animated={false}
              type="password"
              onChange={handlePasswordChange}
              placeholder={t('common:password')}
            />
          )}
        />
        {errors.password && <span>{t('login:inputs.password.error')}</span>}

        <AntdButton
          style={{ fontSize: '18px', width: '100%' }}
          className={isValidPassword ? 'basic-btn' : 'grey-btn'}
          type="submit"
          htmlType="submit"
          disabled={!isValidPassword}
        >
          {t('login:createAccount.label', 'Créer mon compte')}
        </AntdButton>
        <span>
          {t('login:existingAccount.link')}{' '}
          <Link to="/login">{t('login:login')}</Link>
        </span>
      </form>
    </div>
  )
}

SignUp.propTypes = propTypes
export default SignUp
